import { render, staticRenderFns } from "./AddTid.vue?vue&type=template&id=52d8abec&"
import script from "./AddTid.vue?vue&type=script&lang=js&"
export * from "./AddTid.vue?vue&type=script&lang=js&"
import style0 from "./AddTid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports